/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';
import { FrameworkStage, FrameworkPhase } from '../../lib/wwg.classes';

@Component({
  selector: 'wwg-framework-phases-stages',
  templateUrl: './framework-phases-stages.component.html',
  styleUrls: ['./framework-phases-stages.component.scss']
})
export class FrameworkPhasesStagesComponent implements OnInit {

  public phasesArray: Array<FrameworkPhase> = [];

  constructor() { }

  ngOnInit() { }

  public addPhase() {
    this.phasesArray.push(new FrameworkPhase());
  }

  private removePhase(phaseIndex) {
    this.phasesArray.splice(phaseIndex, 1);
  }

  private addStage(phaseIndex) {
    if (!this.phasesArray[phaseIndex].stages) {
      this.phasesArray[phaseIndex].stages = [];
    }
    this.phasesArray[phaseIndex].stages.push(new FrameworkStage());
  }

  private removeStage(phaseIndex, stageIndex) {
    this.phasesArray[phaseIndex].stages.splice(stageIndex, 1);
  }

  private getPhases() {
    return this.phasesArray;
  }

  private getStagess(phaseIndex) {
    return this.phasesArray[phaseIndex];
  }

  private displayPhases(fields: Array<FrameworkPhase>) {
    if (Array.isArray(fields)) {
      this.phasesArray = fields;
    }
  }
}
